import React from 'react';
import './App.css';
import {
    BrowserRouter as Router
} from 'react-router-dom';
import AppRouter from "./App.Router";
import {store} from "./redux/store";
import {Provider} from "react-redux";

function App() {
    return (
        <Provider store={store}>
            <Router>
                <AppRouter/>
            </Router>
        </Provider>
    );
}

export default App;
